// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__XumLK","row":"Node_row__3rJ5c","label":"Node_label__kW6b5","footer":"Node_footer__lUkz6"};